import { render, staticRenderFns } from "./TableChat.vue?vue&type=template&id=fb907832&scoped=true"
import script from "./TableChat.vue?vue&type=script&lang=ts"
export * from "./TableChat.vue?vue&type=script&lang=ts"
import style0 from "./TableChat.vue?vue&type=style&index=0&id=fb907832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb907832",
  null
  
)

export default component.exports